import {Button, Tag} from 'antd';

import UserStats from "./UserStats";
import UserInfo from "./UserInfo/UserInfo";

import styles from "./client-card.module.scss";
const ClientCard = ({name, avatar, birth, date, missionsComplete, totalValue, approve, updateStatus, updating, ...rest}) => {
    const status = approve === 1 ? "validated" : approve === 2 ? "rejected" : "pending";
    const statusColor = approve === 1 ? "green" : approve === 2 ? "red" : "gold";

    return (
        <div>
            <UserStats name={name} avatar={avatar} date={date} birth={birth} missionsComplete={missionsComplete} totalValue={totalValue} />
            {updateStatus && <div className={styles.statusActions}>
                <p>Registration status: <Tag color={statusColor}>{status}</Tag></p>
                <div>
                    <Button type="primary" loading={updating} disabled={approve === 1}
                            onClick={() => updateStatus(rest.id, "verified")}>Validate user</Button>
                    <Button danger loading={updating} disabled={approve === 2}
                            onClick={() => updateStatus(rest.id, "rejected")}>Reject user</Button>
                </div>
            </div>}
            {/*<div className={styles.switcher}>*/}
            {/*    <p>Grant user access</p>*/}
            {/*    <Switch checked={false} />*/}
            {/*</div>*/}
            <UserInfo {...rest} />
        </div>
    )
}

export default ClientCard;
